import VehicleOffers from "./VehicleOffers";

export default VehicleOffers;
